import {createSelector} from 'reselect';
import {isInApp} from '../utils/user-agent';
import {
  getCustomerEmail, getSettings, getStart, isGuest,
} from './selectors';

export const getMarketingPreferenceExperiment = state => (
  state.start.siteDataV2.clientExperiments.marketing_preferences_experiment
);

export const isEmailRequired = createSelector(
  [isGuest, getStart, getSettings, isInApp, getCustomerEmail],
  (guest, start, settings, inApp, email) => {
    const defaultEmailRequired = guest && start.showMarketingPreferences;
    
    if (inApp) {
      return (settings?.force_show_email_for_guest_in_app && !email) || defaultEmailRequired;
    }
    
    return (settings?.force_show_email_for_guest && !email) || defaultEmailRequired;
  },
);
